export default __webpack_public_path__ + "locales/uk-UA/Common.json?hash=aab1d97a833d63d5f7c8c236ee4d5f33";